export const en = {
  'cisco_phone': 'Office phone',
  'email': 'Email',
  'messenger_q': 'Messenger',
  'mobile': 'Mobile',
  'placeholder': 'Notice',
  'zoom': 'Zoom',
  'cisco': 'Cisco Jabber',
  'cms': 'Browser',
};
